export default {
  Confirm: 'Подтвердить',
  Cancel: 'Отменить',
  'The minimum time length is xxxs!': 'Минимальная продолжительность - {{num}}s!',
  'The maximum time length is 50s!': 'Максимальная продолжительность - 50s!',
  'Online service, no download required': 'Онлайн-сервис, не требуется скачать',
  'Add up to 20MB file': 'Добавьте файл размером до 20 МБ',
  'Support common formats': 'Поддерживает общие форматы',
  'Best for general editing requirements': 'Лучше для общих требований редактирования',
  '0 second wait': '0 секунд ожидания',
  'No size limits': 'Никаких ограничений по размеру',
  'Support 1000+ formats': 'Поддержка более 1000 форматов',
  'Stable processing': 'Стабильная обработка',
  'Get access to HitPaw Toolkit!': 'Получите доступ к инструментарию HitPaw!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Поддержка вырезки, обрезки и поворота, регулировки, скорости, добавления музыки, остановки движения и т.д.',
  'The easiest video editing software for beginners':
    'Самое простое ПО для редактирования видео для начинающих',
  'Remove watermark from videos and images in simple clicks':
    'Удаление водяных знаков с видео и изображений простым щелчком мыши',
  'TRY IT FREE': 'ПОПРОБУЙТЕ БЕСПЛАТНО',
  'BUY NOW': 'КУПИТЬ СЕЙЧАС',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Видео успешно проанализировано!Однако в настоящее время мы не поддерживаем обработку файлов размером более 100 МБ.',
  'download the video': 'Загрузите видео',
  'and then use HitPaw Toolkit to proceed.': ' и используйте Toolkit для его обработки.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Вырезать не более 10 фрагментов видео. Получите HitPaw Toolkit для получения дополнительных функций.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'Размер файла не может быть больше 20MB. Получите HitPaw Toolkit для получения дополнительных функций.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'Минимальная продолжительность - 1s! Получите HitPaw Toolkit для получения дополнительных функций.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Добавить не более 3 видео. Получите HitPaw Toolkit для получения дополнительных функций.',
  'This format is not supported currently.': 'Этот формат в настоящее время не поддерживается.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Этот формат в настоящее время не поддерживается. Получите HitPaw Toolkit для получения дополнительных функций.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Не удалось создать видео!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Ошибка загрузки!',
  'Are you sure you want to delete it?': 'Вы уверены, что хотите это удалить?',
  'Failed to extract the audio!': 'Не удалось извлечь аудио!',
  'Coming Soon': 'Скоро будет',
  'Learn more': 'Узнать больше',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Добавьте до 2 файлов. Получите HitPaw Toolkit для получения дополнительных функций.',
  Download: 'Скачать',
  'Try Again': 'Попробуйте еще раз',
  Failed: 'Неудалось',
  'Get Started': 'Начать',
  Start: 'Начать',
  End: 'Конец',
  Export: 'Экспорт',
  'Your audio is ready!': 'Ваше аудио готово!',
  'Download Audio': 'Скачать Аудио',
  YES: 'ДА',
  'Export Failed': 'Экспорт Не удался',
  'Error occurs, the file cannot be added': 'Произошла ошибка, файл не может быть добавлен',
  'Support merging audio files at most': 'Поддержка объединения не более {{num}} аудиофайлов',
  'Are you sure you want to delete this task?': 'Вы уверены, что хотите удалить эту задачу?',
  Processing: 'Обработка',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Не забудьте скачать свой файл, через 24 часа он будет удалён',
  Uploading: 'Загрузка',
  'Go Edit': 'начать редактирование',
  'Generate Files Successfully!': 'Создавать файлы успешно!',
  'Your order is being paid...': 'Ваш заказ оплачивается',
  'Not yet': 'Еще нет',
  'Payment completed': 'Да',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'Загруженный размер видео не может превышать 20 МБ. Скачать Hitpaw Video Converter для получения дополнительных функций.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'Загруженный размер видео не может превышать 500 МБ. Скачать Hitpaw Video Converter для получения дополнительных функций.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'Загруженное разрешение изображения не может превышать 16 мегапикселей. Скачать Hitpaw Video Converter для получения дополнительных функций.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'Функция обработки пакетов доступна только в программном обеспечении настольных компьютеров. Скачать Hitpaw Video Converter для получения дополнительных функций.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'Количество файлов, которые вы обработали сегодня, достигли верхнего предела 300. Загрузите Hitpaw Video Converter для получения дополнительных функций.',
  'Download desktop version to batch process large files with no size limit': 'Скачать версию рабочего стола в процесс партии больших файлов без ограничения размера',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Пакетный конверт видео и аудиофайлы в 1000+ форматов с более высокой скоростью в 120 раз',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Скачать и сохранить видео с сайтов 10000+, таких как YouTube, Tiktok, Instagram и т. Д.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Встроенные функции редактирования видео: слияние, разреза, урожай, водяной знак и т. Д.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Конвертировать Apple Music в MP3 с удаленным DRM (только версия Windows)',
}
